module.exports = __webpack_public_path__ + "assets/images/scene-3_5123a4781066cf4cafe65bf7c6aaea6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/croma-abeldo-dialogs/scene-3.png
// module id = 221
// module chunks = 0